/* 
 	* 指令下发组件 
 	* 描述：InsA5CTimeAlign时间校准指令下发
 	* 创建时间：2017-05-3 
 	* 创建人：baixx 
*/
<template>
    <div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>校准时间</label>
			    <div class="col-sm-8">
			       <datepicker v-model="AlignTime" class="form-control" :options="localeOption" ref="dateT"></datepicker>
			    </div>
			</div>
		    <div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>
    </div>	
</template>
<script>
	import { zh } from 'flatpickr/dist/l10n/zh';
    import Datepicker from 'components/common/datepicker/Datepicker'
	export default {
		name: "InsA5CTimeAlign",
		components: {
			Datepicker
		},
		data() {
			return {	
				localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true
			    },
				AlignTime :"",             //开始时间
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		beforeMount(){
			this.getNowFormatDate()
		},
		
		methods: {
			//获取当前时间
		    getNowFormatDate() {
			    var date = new Date();
			    var seperator1 = "-";
			    var seperator2 = ":";
			    var month = date.getMonth() + 1;
			    var strDate = date.getDate();
			    var strHour = date.getHours()
			    var strMinute = date.getMinutes();
			    var strSecond = date.getSeconds();
			    if (month >= 1 && month <= 9) {
			        month = "0" + month;
			    }
			    if (strDate >= 0 && strDate <= 9) {
			        strDate = "0" + strDate;
			    }
			    if (strHour >= 0 && strHour <= 9) {
			        strHour = "0" + strHour;
			    }
			    if (strMinute >= 0 && strMinute <= 9){
			    	strMinute = "0" + strMinute;
			    }
			    if (strSecond >= 0 && strSecond <= 9){
			    	strSecond = "0" + strSecond;
			    }
			    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
			            + " " + strHour + seperator2 + strMinute
			            + seperator2 + strSecond;
			    this.AlignTime = currentdate
			},
			resetInput(){
				const that = this
				new Promise(function(resolve,reject){
					that.$refs.dateT.handleClear()
					resolve()
				}).then(function(){ 
					that.getNowFormatDate()
				})  
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				let timeAlign = this.AlignTime.replace(/[&\|\\\/\s+:*^%$#@\-]/g,"");
				timeAlign = timeAlign.substring(2)
				if(!timeAlign){
					 this.alertMsg = "校准时间不能为空";
					 return;
				}
			    else{
			    	this.alertMsg = "";
			    }
				let arr = ['SETPRM','C',timeAlign]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// InsA5CTimeAlign.vue?2a60d0f8